export const getForm101Year = (rows) => {
  const rowsWithYear = rows.filter(row => Boolean(row.form101Year));
  return (rowsWithYear.length > 0) ? rowsWithYear[0].form101Year : null;
};
